import React from 'react';

const MetricCard = ({ label, value, delta, deltaColor, suffix = '', subtitle, valueColor }) => (
  <div className="bg-white dark:bg-surface-dark border border-gray-200 dark:border-gray-800 rounded-lg px-3 py-3 text-center h-full overflow-hidden">
    <div className="text-xs text-gray-500 dark:text-gray-400 mb-1 truncate">{label}</div>
    <div className={`text-lg font-semibold truncate ${valueColor || 'text-gray-900 dark:text-gray-100'}`}>
      {value}{suffix}
    </div>
    {delta !== undefined && (
      <div
        className={`text-sm truncate ${
          deltaColor ||
          (delta >= 0 ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400')
        }`}
      >
        {delta >= 0 ? '+' : ''}{delta}{suffix}
      </div>
    )}
    {subtitle && (
      <div className="text-[11px] text-gray-500 dark:text-gray-400 mt-1 truncate" title={subtitle}>
        {subtitle}
      </div>
    )}
  </div>
);

export default MetricCard;
